// extracted by mini-css-extract-plugin
module.exports = {"categoryDescription":"index__categoryDescription___1GRQK","heading":"index__heading___s5jgh"};